import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import isHybridApp from 'static/script/utils/is-hybrid-app';
import openJavascriptHref from 'static/script/app/ui/open-javascript-href';

function SearchResultFilterBoxUI() {
    this.BUTTON_ACTION = {
        collapse: 'collapse',
        expand: 'expand'
    };

    this.HIDDEN_CLASS = 'hidden';

    this.defaultAttrs({
        itemLinks: '[data-nav]',
        filterJavascriptLink: '#view [data-javascript-href]',
        boxHeader: '[data-search-filter-header]'
    });

    this._toggleFilterBox = function() {
        let action;
        this.$node.toggleClass('search-filters-section-open');

        // Event for A/B test
        if (this.$node.parent().hasClass('search-filters-section-categories')) {
            action = this.$node.hasClass('search-filters-section-open')
                ? 'Open'
                : 'Close';
            action = action + ' categories inside filter';
            this._trackCategories(action);
        }
    };

    this._trackCategories = function(label) {
        this.trigger(document, 'analytics:track-event', {
            category: 'Search',
            action: 'Toggle',
            label: label
        });
    };

    this._setLoadingStateOnSelected = function(evt) {
        if (!isHybridApp()) {
            // The spinner ruins the hybrid app
            this.trigger(document, 'ui:side-menu:on-filter-click', {
                forceStart: true
            });
        }

        $(evt.target).addClass('search-filters-list-item-loading');
    };

    this._addSkipNavigationForHybrid = function(evt, origEl) {
        let $el = $(origEl.el),
            cleanedUrl;

        if ($el.attr('href')) {
            cleanedUrl = $el.attr('href') + '#skipNavigation';
            $el.attr('href', cleanedUrl);
        }
    };

    this._filterClick = function(evt) {
        evt.preventDefault();
        const url = $(evt.currentTarget).attr('data-javascript-href');
        openJavascriptHref(url, evt);
    };

    this._nullFunction = function() {
        // Empty function for FastClick workaround
        // We need to bind touchstart and touchend - they dont register correctly without this
        // 'click' is not always registered.
    };

    this.after('initialize', function() {
        this.on('click', {
            boxHeader: this._toggleFilterBox,
            itemLinks: this._setLoadingStateOnSelected,
            filterJavascriptLink: this._filterClick
        });

        if (isHybridApp()) {
            this.on('click', {
                itemLinks: this._addSkipNavigationForHybrid
            });
        }

        this.on('touchstart touchend', {
            itemLinks: this._nullFunction
        });
    });
}

export default defineComponent.component(SearchResultFilterBoxUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/search-result-filter-box-ui.js